import * as yup from 'yup';
import controlDictionary from '../../Controls/controlDictionary';
import PageState from '../../Shared/pageState';

export default (
  page: PageState
): {
  [key: string]: yup.AnySchema;
} => {
  let controlYupSchemas: {
    [key: string]: yup.AnySchema;
  } = {};

  for (const control of page.controls) {
    controlYupSchemas = {
      ...controlYupSchemas,
      ...controlDictionary[control.kind].yupSchemaEntry(control)
    };
  }

  return controlYupSchemas;
};
